import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './CompanyContactPage.css';

const CompanyContactPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const supplierId = id || '68';
  const [activeTab, setActiveTab] = useState('contact');
  const [formData, setFormData] = useState({
    message: '',
    email: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Inquiry submitted:', formData);
  };

  const companyData = {
    name: 'Eiffage Construction',
    logo: 'https://api.builder.io/api/v1/image/assets/TEMP/4fe949ae73c9ac863b6fb61997bb04e8c261413f?width=160',
    badge: 'Global',
    verified: true,
    country: 'United State',
    years: '01 Year',
    type: 'Manufacture',
    reviews: 0,
    products: 20
  };

  const contactPerson = {
    name: 'Ms. Lomen Fan',
    role: 'Sales Manager',
    avatar: 'https://api.builder.io/api/v1/image/assets/TEMP/dab3e80e1404e8f3ea4dcc6e9c43cc98fe202f14?width=160'
  };

  const contactDetails = {
    telephone: 'View Mobile',
    address: 'T6 Building. 3501, Fuxing World Financial Center. Dong Road, Kaifu District',
    website: 'httpsflwww.globalsources.com/\'sinomada.co',
    city: 'Changsha',
    country: 'Dubai',
    zipCode: '410000'
  };

  return (
    <div className="company-contact-page">
      <Header />
      
      {/* Company Header Section */}
      <div className="cc-company-header">
        <div className="cc-company-header-content">
          <div className="cc-company-info-row">
            <div className="cc-company-identity">
              <img 
                src={companyData.logo} 
                alt="Company Logo" 
                className="cc-company-logo" 
              />
              <div className="cc-company-details">
                <h1 className="cc-company-name">{companyData.name}</h1>
                <div className="cc-company-meta">
                  <div className="cc-meta-badges">
                    <div className="cc-global-badge">
                      <img 
                        src="https://api.builder.io/api/v1/image/assets/TEMP/050559d54da8d35ba6d11841efdb737d4c3ae660?width=44" 
                        alt="Platinum" 
                        className="cc-platinum-icon" 
                      />
                      <span>{companyData.badge}</span>
                    </div>
                    {companyData.verified && (
                      <div className="cc-verified-badge">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                          <path d="M22 11C22 11.9323 20.7329 12.6871 20.5034 13.5472C20.2653 14.4377 20.9782 15.7221 20.528 16.5015C20.0705 17.2923 18.597 17.314 17.9562 17.9562C17.314 18.5984 17.2923 20.0705 16.5014 20.528C15.7221 20.9782 14.4377 20.2653 13.5472 20.5034C12.6871 20.7329 11.9337 22 11 22C10.0663 22 9.31291 20.7329 8.45276 20.5034C7.56231 20.2653 6.27788 20.9782 5.49856 20.528C4.70769 20.0705 4.68605 18.597 4.04382 17.9562C3.4016 17.3154 1.92954 17.2923 1.47205 16.5015C1.02177 15.7221 1.73472 14.4377 1.49659 13.5472C1.26712 12.6871 0 11.9338 0 11C0 10.0663 1.26712 9.31292 1.49659 8.45278C1.73472 7.56233 1.02177 6.27789 1.47205 5.49857C1.92954 4.7077 3.40305 4.68605 4.04382 4.04383C4.68605 3.40161 4.70769 1.92955 5.49856 1.47206C6.27788 1.02178 7.56231 1.73472 8.45276 1.49659C9.31291 1.26712 10.0663 0 11 0C11.9337 0 12.6871 1.26712 13.5472 1.49659C14.4377 1.73472 15.7221 1.02178 16.5014 1.47206C17.2923 1.92955 17.314 3.40305 17.9562 4.04383C18.5984 4.68461 20.0705 4.7077 20.528 5.49857C20.9782 6.27789 20.2653 7.56233 20.5034 8.45278C20.7329 9.31292 22 10.0663 22 11Z" fill="#29ABE2"/>
                          <path d="M16.5881 7.6017C16.1234 7.137 15.3701 7.137 14.9054 7.6017L10.0317 12.4754L8.00835 10.452C7.54364 9.9873 6.79029 9.9873 6.32558 10.452C5.86087 10.9167 5.86087 11.6701 6.32558 12.1348L9.14847 14.9577C9.39237 15.2016 9.7142 15.317 10.0331 15.3055C10.3521 15.317 10.6739 15.2016 10.9178 14.9577L16.5896 9.28591C17.0543 8.8212 17.0543 8.06786 16.5896 7.60315L16.5881 7.6017Z" fill="white"/>
                        </svg>
                        <span>Verified</span>
                      </div>
                    )}
                  </div>
                  <div className="cc-country-info">
                    <div className="cc-flag-wrapper">
                      <img 
                        src="https://api.builder.io/api/v1/image/assets/TEMP/23ed0e62e10103a924032bcc2322be51eddf65ca?width=124" 
                        alt="Flag" 
                        className="cc-flag-large" 
                      />
                    </div>
                    <span className="cc-country-text">
                      <span className="cc-country-name">{companyData.country}</span>
                      <span className="cc-separator"> / </span>
                      <span className="cc-years">{companyData.years}</span>
                    </span>
                  </div>
                  <div className="cc-manufacture-info">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M14.5 5H12V6H14.5V9H11V10H12.5V11.071C12.0287 11.1927 11.6179 11.4821 11.3447 11.885C11.0715 12.2879 10.9546 12.7766 11.0159 13.2595C11.0773 13.7424 11.3126 14.1864 11.6779 14.5082C12.0431 14.83 12.5132 15.0075 13 15.0075C13.4868 15.0075 13.9569 14.83 14.3221 14.5082C14.6874 14.1864 14.9227 13.7424 14.9841 13.2595C15.0454 12.7766 14.9285 12.2879 14.6553 11.885C14.3821 11.4821 13.9713 11.1927 13.5 11.071V10H14.5C14.7651 9.9996 15.0192 9.89412 15.2067 9.70667C15.3941 9.51922 15.4996 9.26509 15.5 9V6C15.5 5.73478 15.3946 5.48043 15.2071 5.29289C15.0196 5.10536 14.7652 5 14.5 5ZM14 13C14 13.1978 13.9414 13.3911 13.8315 13.5556C13.7216 13.72 13.5654 13.8482 13.3827 13.9239C13.2 13.9996 12.9989 14.0194 12.8049 13.9808C12.6109 13.9422 12.4327 13.847 12.2929 13.7071C12.153 13.5673 12.0578 13.3891 12.0192 13.1951C11.9806 13.0011 12.0004 12.8 12.0761 12.6173C12.1518 12.4346 12.28 12.2784 12.4444 12.1685C12.6089 12.0586 12.8022 12 13 12C13.2651 12.0004 13.5192 12.1059 13.7067 12.2933C13.8941 12.4808 13.9996 12.7349 14 13ZM9.5 3H7V4H9.5V7H6V8H7.5V11.071C7.02867 11.1927 6.61791 11.4821 6.3447 11.885C6.07149 12.2879 5.9546 12.7766 6.01594 13.2595C6.07728 13.7424 6.31263 14.1864 6.67788 14.5082C7.04314 14.83 7.51321 15.0075 8 15.0075C8.48679 15.0075 8.95686 14.83 9.32212 14.5082C9.68737 14.1864 9.92272 13.7424 9.98406 13.2595C10.0454 12.7766 9.92851 12.2879 9.6553 11.885C9.3821 11.4821 8.97133 11.1927 8.5 11.071V8H9.5C9.76522 8 10.0196 7.89464 10.2071 7.7071C10.3946 7.51957 10.5 7.26521 10.5 7V4C10.5 3.73478 10.3946 3.48043 10.2071 3.29289C10.0196 3.10536 9.76522 3 9.5 3ZM9 13C9 13.1978 8.94135 13.3911 8.83147 13.5556C8.72159 13.72 8.56541 13.8482 8.38268 13.9239C8.19996 13.9996 7.99889 14.0194 7.80491 13.9808C7.61093 13.9422 7.43275 13.847 7.29289 13.7071C7.15304 13.5673 7.0578 13.3891 7.01921 13.1951C6.98063 13.0011 7.00043 12.8 7.07612 12.6173C7.15181 12.4346 7.27998 12.2784 7.44443 12.1685C7.60888 12.0586 7.80222 12 8 12C8.26509 12.0004 8.51922 12.1059 8.70667 12.2933C8.89412 12.4808 8.9996 12.7349 9 13ZM4.5 1H1.5C1.23478 1 0.98043 1.10536 0.792893 1.29289C0.605357 1.48043 0.5 1.73478 0.5 2V5C0.5 5.26522 0.605357 5.51957 0.792893 5.70711C0.98043 5.89464 1.23478 6 1.5 6H2.5V11.071C2.02867 11.1927 1.61791 11.4821 1.3447 11.885C1.07149 12.2879 0.954603 12.7766 1.01594 13.2595C1.07728 13.7424 1.31263 14.1864 1.67788 14.5082C2.04314 14.83 2.51321 15.0075 3 15.0075C3.48679 15.0075 3.95686 14.83 4.32212 14.5082C4.68737 14.1864 4.92272 13.7424 4.98406 13.2595C5.0454 12.7766 4.92851 12.2879 4.6553 11.885C4.38209 11.4821 3.97133 11.1927 3.5 11.071V6H4.5C4.76522 6 5.01957 5.89464 5.20711 5.70711C5.39464 5.51957 5.5 5.26522 5.5 5V2C5.5 1.73478 5.39464 1.48043 5.20711 1.29289C5.01957 1.10536 4.76522 1 4.5 1ZM4 13C4 13.1978 3.94135 13.3911 3.83147 13.5556C3.72159 13.72 3.56541 13.8482 3.38268 13.9239C3.19996 13.9996 2.99889 14.0194 2.80491 13.9808C2.61093 13.9422 2.43275 13.847 2.29289 13.7071C2.15304 13.5673 2.0578 13.3891 2.01921 13.1951C1.98063 13.0011 2.00043 12.8 2.07612 12.6173C2.15181 12.4346 2.27998 12.2784 2.44443 12.1685C2.60888 12.0586 2.80222 12 3 12C3.26522 12 3.51957 12.1054 3.70711 12.2929C3.89464 12.4804 4 12.7348 4 13ZM1.5 5V2H4.5L4.501 5H1.5Z" fill="#6D6D6D"/>
                    </svg>
                    <span>{companyData.type}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="cc-header-right">
              <div className="cc-stats-box">
                <span className="cc-stat">{companyData.reviews} Reviews</span>
                <div className="cc-stat-divider"></div>
                <span className="cc-stat">{companyData.products} Products</span>
              </div>
              <button className="cc-bookmark-btn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M22 0H11.5C11.1022 0 10.7206 0.158035 10.4393 0.43934C10.158 0.720644 10 1.10218 10 1.5V18C10.0001 18.1338 10.036 18.2652 10.1039 18.3805C10.1719 18.4958 10.2695 18.5908 10.3866 18.6557C10.5037 18.7206 10.636 18.7529 10.7698 18.7494C10.9036 18.7458 11.034 18.7066 11.1475 18.6356L16.75 15.1341L22.3534 18.6356C22.4669 18.7063 22.5972 18.7454 22.7309 18.7488C22.8646 18.7522 22.9967 18.7198 23.1136 18.655C23.2306 18.5902 23.3281 18.4953 23.396 18.3801C23.4639 18.2649 23.4998 18.1337 23.5 18V1.5C23.5 1.10218 23.342 0.720644 23.0607 0.43934C22.7794 0.158035 22.3978 0 22 0ZM22 16.6472L17.1466 13.6144C17.0274 13.5399 16.8896 13.5004 16.7491 13.5004C16.6085 13.5004 16.4708 13.5399 16.3516 13.6144L11.5 16.6472V1.5H22V16.6472Z" fill="#969696"/>
                </svg>
              </button>
            </div>
          </div>
          <div className="cc-tabs">
            <button 
              className={`cc-tab ${activeTab === 'home' ? 'active' : ''}`}
              onClick={() => navigate(`/supplier/${supplierId}`)}
            >
              Home
            </button>
            <button 
              className={`cc-tab ${activeTab === 'profile' ? 'active' : ''}`}
              onClick={() => navigate(`/supplier/${supplierId}/profile`)}
            >
              Company Profile
            </button>
            <button 
              className={`cc-tab ${activeTab === 'product' ? 'active' : ''}`}
              onClick={() => navigate(`/supplier/${supplierId}/products`)}
            >
              Product
            </button>
            <button 
              className={`cc-tab ${activeTab === 'contact' ? 'active' : ''}`}
              onClick={() => navigate(`/supplier/${supplierId}/contact`)}
            >
              Contact
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="cc-main-content">
        {/* Breadcrumb */}
        <div className="cc-breadcrumb">
          <Link to="/">Home</Link>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 13L10 9L6 5" stroke="#505050" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <Link to="/company-profile">Supplier homepage</Link>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 13L10 9L6 5" stroke="#505050" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="cc-breadcrumb-current">contact</span>
        </div>

        {/* Contact Section */}
        <div className="cc-contact-section">
          {/* Contact Info Card */}
          <div className="cc-contact-info-card">
            {/* Contact Person */}
            <div className="cc-contact-person">
              <img 
                src={contactPerson.avatar} 
                alt={contactPerson.name} 
                className="cc-contact-avatar" 
              />
              <div className="cc-contact-person-info">
                <span className="cc-contact-person-name">{contactPerson.name}</span>
                <span className="cc-contact-person-role">{contactPerson.role}</span>
              </div>
            </div>

            {/* Separator */}
            <div className="cc-contact-separator"></div>

            {/* Contact Details */}
            <div className="cc-contact-details">
              <div className="cc-contact-labels">
                <span>Telephone:</span>
                <span>Address:</span>
                <span>Homepage website:</span>
                <span>City:</span>
                <span>Country:</span>
                <span>Zip 'Postal Code:</span>
              </div>
              <div className="cc-contact-values">
                <a href="#" className="cc-view-mobile">{contactDetails.telephone}</a>
                <span>{contactDetails.address}</span>
                <span>{contactDetails.website}</span>
                <span>{contactDetails.city}</span>
                <span>{contactDetails.country}</span>
                <span>{contactDetails.zipCode}</span>
              </div>
            </div>
          </div>

          {/* Inquiry Form */}
          <div className="cc-inquiry-form-card">
            <h2 className="cc-inquiry-title">Send a direct inquiry to this supplier</h2>
            
            <form onSubmit={handleSubmit} className="cc-inquiry-form">
              <div className="cc-form-recipient">
                <span className="cc-recipient-label">To:</span>
                <span className="cc-recipient-name">{companyData.name}</span>
              </div>

              <div className="cc-form-group">
                <label className="cc-form-label">Message:</label>
                <div className="cc-textarea-wrapper">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="enter product details"
                    className="cc-form-textarea"
                  />
                  <div className="cc-textarea-resize">
                    <svg width="19" height="16" viewBox="0 0 20 17" fill="none">
                      <path d="M9.26709 16.4229L18.7925 10.9229" stroke="#6D6D6D"/>
                      <path d="M5.26709 14.4229L18.2671 6.42285" stroke="#6D6D6D"/>
                      <path d="M0.26709 12.4229L19.2671 0.422852" stroke="#6D6D6D"/>
                    </svg>
                  </div>
                </div>
              </div>

              <div className="cc-form-group cc-form-group-email">
                <label className="cc-form-label">Email:</label>
                <div className="cc-input-wrapper">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Please enter your business email address"
                    className="cc-form-input"
                  />
                </div>
              </div>

              <button type="submit" className="cc-submit-btn">
                Send Inquire
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CompanyContactPage;
